import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlHelper {
  public apiUrl = {
    Login: {
      UserLogin: 'account/login',
      logout: 'account/logout/{Id}',
      VerifyOTP: 'account/verify-otp',
      PrivacyPolicyAndLegal: 'general/privacy-policy',
    },
    Dashboard: {
      GetDashboardData: 'dashboard/data',
      GetChartData: 'dashboard/graph-claim-count',
      GetClaimByCompany: 'dashboard/claim-count-by-company-id',
    },
    Claim: {
      GetClaimByProject: 'claim/claim-by-project',
      ExportClaimByProject: 'claim/claim-by-project/export',
      SaveClaimByProjectAmount: 'claim/save-claim-by-project',
      GetClaimWorkFlow: 'claim/list',
      SaveClaimWorkFlowItemStatus: 'claim/save-claim-workflow-item-status',
    },
    General: {
      GetCountryList: 'country/list',
      GetCountryListForUKNonUK: 'country/list-uk-nonuk',
      GetStateByCountryId: 'state/list/{Id}',
      GetCityByStateId: 'city/list/{Id}',
      downloadTemplete: 'general/download-template',
    },
    ForgotPassword: {
      ForgotSendEmail: 'account/forgot-password',
      ResetPassword: 'account/reset-password',
      ValidateResetPassword: 'account/validate-reset-password',
    },
    User: {
      GetUserList: 'user/list',
      DeleteUser: 'user/delete/{Id}',
      AddEditUser: 'user/save',
      GetUserById: 'user/{Id}',
      ActiveInactiveUser: 'user/active-inactive/{Id}',
      LoginDevicesList: 'user/login-device-list',
      LogoutDevice: 'user/logout-device/{Id}',
    },
    Staff: {
      AddEditUser: 'user/useraddedit-admin',
      GetUserById: 'user/{Id}',
      ActiveInactiveUser: 'user/active-inactive/{Id}',
    },
    Role: {
      GetRoleList: 'role/list',
      GetRoleById: 'role/{Id}',
      SaveUpdateRole: 'role/save',
      DeleteRole: 'role/delete/{Id}',
      GetRole: 'role/list',
      GetRoleDropDwon: 'role/role-dropdown',
      GetRoleRightList: 'role/role-right-list',
      GetRoleRightListUserWise: 'role/role-right-list-user-wise/{Id}',
      SaveRoleRights: 'role/save-right',
      SaveRoleRightsUserWise: 'role/user-right',
    },
    country: {
      GetCountryList: 'country/list',
    },
    State: {
      GetStateList: 'state/list/{Id}',
    },
    city: {
      GetCityList: 'city/list/{Id}',
    },
    MenuList: {
      GetMenuList: 'menu/list',
      GetUserCostCategoryRights: 'menu/cost-category-rights',
      GetSummaryOfExpenditure: 'menu/expenditure-count',
    },
    Software: {
      GetSoftwareList: 'software/list',
      AddEditSoftware: 'software/save',
      GetSoftwareById: 'software/{Id}',
      DeleteSoftware: 'software/delete/{Id}',
      UploadSoftware: 'software/upload',
      ExportSoftware: 'software/export',
    },
    Project: {
      GetProjectList: 'project/list',
      // GetProjectListCompanyWise: 'project/project-by-company/{Id}',
      AddEditProject: 'project/save',
      ExportProject: 'project/export',
      GetProjectById: 'project/{Id}',
      DeleteProject: 'project/delete/{Id}',
      GetProjectListWithOutPagination: 'project/{companyId}/{claimYearId}',
    },
    Company: {
      GetCompanyList: 'company/list',
      AddEditCompany: 'company/save',
      GetCompanyById: 'company/{Id}',
      DeleteCompany: 'company/delete/{Id}',
      GetCompanyListWithoutPagination: 'company/dropdown/list',
      GetFinancialYear: 'claim-year/list/{Id}',
      GetCompanyDetailInformation: 'company/company-information',
      ExportCompanyDetailInformation: 'company/export',
    },
    DataLicenceAndCloudCompution: {
      GetDataLicenceList: 'data-licence/list',
      AddEditDataLicence: 'data-licence/save',
      GetDataLicenceById: 'data-licence/{Id}',
      DeleteDataLicence: 'data-licence/delete/{Id}',
      DataLicenceUpload: 'data-licence/upload',
      ExportDataLicenceAndCloudCompution: 'data-licence/export',
    },
    CloudComputing: {
      GetCloudComputingList: 'cloud-computing/list',
      AddEditCloudComputing: 'cloud-computing/save',
      GetCloudComputingById: 'cloud-computing/{Id}',
      DeleteCloudComputing: 'cloud-computing/delete/{Id}',
      UploadCloudComputing: 'cloud-computing/upload',
      ExportCloudComputing: 'cloud-computing/export',
    },
    Contractor: {
      GetContractorList: 'contractor/list',
      AddEditContractor: 'contractor/save',
      GetContractorById: 'contractor/{Id}',
      DeleteContractor: 'contractor/delete/{Id}',
      UploadContractor: 'contractor/upload',
      ExportContractor: 'contractor/download-contractor',
    },
    EPWUnConnectedCost: {
      GetEPWConncetedCostList: 'epw-unconnected-cost/list',
      AddEditEPWConncetedCost: 'epw-unconnected-cost/save',
      GetEPWConncetedCostById: 'epw-unconnected-cost/{Id}',
      DeleteEPWConncetedCost: 'epw-unconnected-cost/delete/{Id}',
      ExportEpwUnconnectedCost: 'epw-unconnected-cost/export',
      ImportEpwUnconnectedCost: 'epw-unconnected-cost/upload',
      DeleteAllEPWConncetedCost: 'epw-unconnected-cost/delete-all',
    },
    Employee: {
      GetEmployeeList: 'employee/list',
      AddEditEmployee: 'employee/save',
      GetEmployeeById: 'employee/details/{Id}',
      DeleteEmployee: 'employee/delete/{Id}',
      Addemployeepay: 'employee/employeepay',
      GetEmployeePayById: 'employee/pay/{Empid}',
      GetEmployeeListDropDown: 'employee/drop-down-list',
      GetJobRole: 'employee/role/{Id}',
      ExporEmployee: 'employee/export',
      UploadEmployee: 'employee/upload',
      EmployeeAddConfirmation: 'employee/add-confirmation',
      DeleteAllEmployee: 'employee/delete-all',
    },
    DocumentUpload: {
      SaveDocument: 'general/upload-document',
      DeleteDocument: 'general/delete-document/{Id}',
      GetDocumentList: 'general/document-list',
      DocumentRename: 'general/document-rename',
    },
    Utility: {
      SaveUtility: 'utility/save',
      DeleteUtility: 'utility/delete-utility/{Id}',
      GetUtilityDropDownList: 'utility/get-utility-dropdown',
      GetUtilityList: 'utility/list',
      GetUtilityDetail: 'utility/detail/{Id}',
      GetProjectListOfUtility: 'utility/get-project-list-utility',
      ExportUtility: 'utility/export',
      UploadUtility: 'utility/upload',
    },
    ConsumableItems: {
      SaveConsumableItems: 'consumable-item/save',
      DeleteConsumableItems: 'consumable-item/delete/{Id}',
      GetConsumableItemsList: 'consumable-item/list',
      GetConsumableItemsDetail: 'consumable-item/{Id}',
      ExportConsumableItems: 'consumable-item/export',
      UploadConsumableItems: 'consumable-item/upload',
    },

    PaymentsToClinicalTrial: {
      SavePaymentsToClinicalTrial:
        'payments-to-clinical-trial-participants/save',
      DeletePaymentsToClinicalTrial:
        'payments-to-clinical-trial-participants/delete/{Id}',
      GetPaymentsToClinicalTrialList:
        'payments-to-clinical-trial-participants/list',
      GetPaymentsToClinicalTrialDetail:
        'payments-to-clinical-trial-participants/{Id}',
      ExportPaymentsToClinicalTrial:
        'payments-to-clinical-trial-participants/export',
      UploadPaymentsToClinicalTrial:
        'payments-to-clinical-trial-participants/upload',
    },

    ChangePassword: {
      ChangePassword: 'account/change-password',
    },
    EPWConnectedParty: {
      GetEPWConnectedPartyList: 'epw-connected-party/list',
      SaveEPWConnectedParty: 'epw-connected-party/save',
      GetEPWConnectedPartyById: 'epw-connected-party/{Id}',
      DeleteEPWConnectedParty: 'epw-connected-party/delete/{Id}',
      ExportEPWConnectedParty: 'epw-connected-party/export',
      UploadEPWConnectedParty: 'epw-connected-party/upload',
      DeleteAllEPWConnectedParty: 'epw-connected-party/delete-all',
    },
    SubContractor: {
      GetSubContractorList: 'sub-contractor-connected/list',
      AddEditSubContractor: 'sub-contractor-connected/save',
      GetSubContractorById: 'sub-contractor-connected/{Id}',
      DeleteSubContractor: 'sub-contractor-connected/delete/{Id}',
      UploadSubContractor: 'sub-contractor-connected/upload',
      ExportSubContractor: 'sub-contractor-connected/export',
      DeleteAllSubContractor: 'sub-contractor-connected/delete-all',
    },
    SubContractorUnconnected: {
      GetSubContractorUnconnectedList: 'sub-contractor-unconnected/list',
      AddEditSubContractorUnconnected: 'sub-contractor-unconnected/save',
      GetSubContractorUnconnectedById: 'sub-contractor-unconnected/{Id}',
      DeleteSubContractorUnconnected: 'sub-contractor-unconnected/delete/{Id}',
      UploadSubContractorUnconnected: 'sub-contractor-unconnected/upload',
      ExportSubContractorUnconnected: 'sub-contractor-unconnected/export',
    },
    Notification: {
      GetNotificationList: 'notification/list',
      UpdateReadStatus: 'notification/update-read-status',
    },
    ActivityLog: {
      GetActivityLogList: 'activity-log/list',
      UserListByRoleId: 'activity-log/user-list',
    },
    Client: {
      GetClientList: 'client/list',
      DeleteClient: 'client/delete/{Id}',
      AddEditClient: 'client/save',
      GetClientById: 'client/{Id}',
    },
    Dyanmic: {
      GetDynamic: 'company/project-by-company/{Id}',
      SoftwareDataLicence: 'software/software-form-details',
      GetEmployeeDetails: 'employee/staff-cost-by-project-form',
      GetEPWUnConnectedDetails:
        'epw-unconnected-cost/epw-unconnected-form-details',
      GetEPWConnectedDetails: 'epw-connected-party/epw-form-details',
      GetSubContractedConnectedDetails:
        'sub-contractor-connected/sub-contractor-form-details',
      GetSubContractedUnConnectedDetails:
        'sub-contractor-unconnected/sub-contractor-un-connected-form-details',
      GetDataLicenceDetails: 'data-licence/data-licences-form-details',
      GetUtilityDetails: '',
      GetCloudCostDetails: 'cloud-computing/cloud-computing-form-details',
      GetMaterialDetails: 'consumable-item/consumable-item-form-details',
    },
    DropDown: {
      GetSoftwareDropDown: 'software/cost/{Id}',
      GetEmployeeDropDown: 'employee/cost/{Id}',
      GetEPWUnConnectedDropDown: 'epw-unconnected-cost/cost-unconnected/{Id}',
      GetEPWConnectedDropDown: 'epw-connected-party/cost/{Id}',
      GetSubContractedConnectedDropDown: 'sub-contractor-connected/cost/{Id}',
      GetSubContractedUnConnectedDropDown:
        'sub-contractor-unconnected/cost-unconnected/{Id}',
      GetDataLicenceDropDown: 'data-licence/cost/{Id}',
      GetUtilityDropDown: '',
      GetCloudCostDropDown: 'cloud-computing/cost/{Id}',
      GetMaterialDropDown: 'consumable-item/cost/{Id}',
    },
    CommonFormSubmit: {
      SaveProjectForm: 'software/save-software-cost-form',
      SaveEmployeeForm: 'employee/save-employee-cost-form',
      SaveEPWUnConnectedForm: 'epw-unconnected-cost/save-epw-unconn-cost-form',
      SaveEPWConnectedForm: 'epw-connected-party/save-epw-conn-cost-form',
      SaveSubContractedConnected:
        'sub-contractor-connected/save-contractor-conn-cost-form',
      SaveSubContractedUnConnected:
        'sub-contractor-unconnected/save-contractor-unconn-cost-form',
      SaveDataLicenceForm: 'data-licence/save-data-licences-cost-form',
      SaveUtilityForm: 'utility/save-utility-cost-form',
      SaveCloudCostForm: 'cloud-computing/cloud-computing-cost-form',
      SaveMaterialFormData: 'consumable-item/consumable-item-save-cost-form',
    },
    CompanyInfoForm: {
      AddEditCompanyInfoForm: 'company/save-details',
      EditCompanyTaxInfoForm: 'company/save-company-tax',
    },
    ClaimYearManagement: {
      GetClaimYearList: 'claim-year/list',
      DeleteClaimYear: 'claim-year/delete/{Id}',
      AddEditClaimYear: 'claim-year/save',
      GetClaimYearById: 'claim-year/{Id}',
      GetClaimStatusList: 'claim-year/status',
      GetAccountingPeriodList: 'claim-year/accountig-period-list',
      CopyClaim: 'claim-year/copy-claim-data',
      ClaimYearExists: 'claim-year/exists',
    },
    EPWUnconnectedCostResource: {
      GetEPWUnconnectedCostResource: 'epw-unconnected-resource/list',
      SaveEPWUnconnectedCostResource: 'epw-unconnected-resource/save',
      ExportEPWUnconnectedCost: 'epw-unconnected-resource/export',
      ExportExpenditureCategoryCost:
        'epw-unconnected-resource/export-cost-category',
    },
    EPWconnectedCostResource: {
      GetEPWconnectedCostResource: 'epw-connected-resource/list',
      SaveEPWconnectedCostResource: 'epw-connected-resource/save',
      ExportEPWconnectedCostResource: 'epw-connected-resource/export',
      ExportEPWconnectedCostCategory:
        'epw-connected-resource/export-cost-category',
    },
    StaffCostResource: {
      employeeList: 'staff-cost-resource/list',
      employeeResourceSave: 'staff-cost-resource/save',
      employeeResourceExport: 'staff-cost-resource/export',
      costCategoryExport: 'staff-cost-resource/export-qualifying-expenditure',
    },
    SubcontractorUnconnectedCostResource: {
      GetSubcontractorUnconnectedCostResource:
        'sub-contractor-unconnected-resource/list',
      SaveSubcontractorUnconnectedCostResource:
        'sub-contractor-unconnected-resource/save',
      ExportSubcontractorUnconnectedCostResource:
        'sub-contractor-unconnected-resource/export',
      ExportSubcontractorUnconnectedCostCategory:
        'sub-contractor-unconnected-resource/export-cost-category',
    },
    SubContractorConnectedResource: {
      subContractorConnectedList: 'sub-contractor-connected-resource/list',
      subContractorConnectedSave: 'sub-contractor-connected-resource/save',
      subContractorConnectedExport: 'sub-contractor-connected-resource/export',
      subContractorConnectedExportForCostCategory:
        'sub-contractor-connected-resource/export-cost-category',
    },
    DataLicenceResource: {
      dataLicenceList: 'data-licence-resource/list',
      SavedataLicenceResource: 'data-licence-resource/save',
      ExportdataLicenceResource: 'data-licence-resource/export',
      ExportdataLicenceCostCategory:
        'data-licence-resource/export-cost-category',
    },
    SoftwareResource: {
      GetSoftwareResource: 'software-resource/list',
      SaveSoftwareResource: 'software-resource/save',
      ExportSoftwareResource: 'software-resource/export',
      ExportSoftwareCostCategory: 'software-resource/export-cost-category',
    },
    PaymentToClinicalTrialResource: {
      GetPaymentToClinicalTrialResource:
        'payments-to-clinical-trial-participants-resource/list',
      SavePaymentToClinicalTrialResource:
        'payments-to-clinical-trial-participants-resource/save',
      ExportPaymentToClinicalTrialResource:
        'payments-to-clinical-trial-participants-resource/export',
      ExportPaymentToClinicalTrialCostCategory:
        'payments-to-clinical-trial-participants-resource/export-cost-category',
    },
    ConsumableItemResource: {
      GetConsumableItemResource: 'consumable-item-resource/list',
      SaveConsumableItemResource: 'consumable-item-resource/save',
      ExportConsumableItemResource: 'consumable-item-resource/export',
      ExportConsumableItemCostCategory:
        'consumable-item-resource/export-cost-category',
    },
    CloudComputingResource: {
      cloudComputingList: 'cloud-computing-resource/list',
      SavecloudComputingResource: 'cloud-computing-resource/save',
      ExportcloudComputingResource: 'cloud-computing-resource/export',
      ExportcloudComputingCostCategory:
        'cloud-computing-resource/export-cost-category',
    },
    PayCap: {
      PayCapList: 'payecap/details',
      SavePayeCapList: 'payecap/save',
      ExportPayeCapList: 'payecap/export',
    },
    UtilityResource: {
      GetUtilityResourceList: 'utility-resource/list',
      SaveUtilityCost: 'utility-resource/save-utility-cost',
      GetUtilityCost: 'utility-resource/get-utility-cost',
      ExportUtilityCost: 'utility-resource/export-cost-category',
    },
    RNDIntensityCalculation: {
      RNDIntensityList: 'rnd-intensity-calculation/details',
      SaveRNDIntensityList: 'rnd-intensity-calculation/save',
      ExportRNDIntensityList: 'rnd-intensity-calculation/export',
    },
    BenifitSummary: {
      BenifitSummaryList:
        'rnd-intensity-calculation/intensity-support-scheme-benefit',
      BenifitSummaryExport:
        'rnd-intensity-calculation/intensity-support-scheme-benefit/export',
    },
    BenifitSummaryMergeScheme: {
      BenifitSummaryMergeSchemeList:
        'merged-expenditure-credit-summary/details',
      SaveRNDIntensityList: 'merged-expenditure-credit-summary/save',
      ExportBenifitSummaryMergeExpenditure:
        'merged-expenditure-credit-summary/export',
    },
    CT600Extract: {
      CT600ExtractList: 'ct600-extract/details',
      SaveCT600Extract: 'ct600-extract/save',
      ExtractExcel: 'ct600-extract/export-extract',
    },
    CT600LMerge: {
      CT600LMergeList: 'ct600lMerge/details',
      SaveCT600LMerge: 'ct600lMerge/save',
      ExtractMergeExcel: 'ct600lMerge/export-merged',
    },
    ClaimDashboard: {
      GetClaimDashboardDetail: 'claim-dashboard/details',
      ExportClaimDashboardDetail: 'claim-dashboard/export',
    },
    CompletionCheckList: {
      GetCompletionChecklist: 'completion-checklist/details',
      SaveCompletionCheckList: 'completion-checklist/save',
      ExportCompletionCheckList: 'completion-checklist/export',
    },
    ClaimLock: {
      LockUnlockClaim: 'claim-year/lock-unlock-claim',
    },
    AIFProjectDescription: {
      GetStepper: 'aif-project/details',
      SaveStepper: 'aif-project/save',
      DeleteStepperAnswer: 'aif-project/delete-answer/{Id}',
      GetAIFFormDetail: 'aif-project/document-export',
      GetAIFFormProjectDetail: 'aif-project/additional-information-project-description',
      ExportAIFFormDetail: 'aif-project/additional-information-word-document',
      ProjectExportAIFFormDetail: 'aif-project/word-document',
      SaveAIFDocumentDetail: 'aif-project/save-document-detail',
      DeleteConnectedCompany: 'aif-project/delete/{Id}',
    },
    Notes: {
      GetUserList: 'note/user-by-companyid/{Id}',
      GetNoteList: 'note/list',
      SaveNote: 'note/save',
      GetNoteById: 'note/details/{Id}',
      SendReply: 'note/save-reply',
      ChangeStatus: 'note/status',
      DeleteNote: 'note/Delete/{Id}',
    },
    RNDClaimApproach: {
      GetStepper: 'rd-claim-approach/details',
      SaveStepper: 'rd-claim-approach/save',
      GetWordDetailsForClaimApprocahReport: 'rd-claim-approach/word-details',
      ExportWordDetailsForClaimApprocahReport:
        'rd-claim-approach/claim-approach-word-document',
    },
    SummaryResource: {
      ExportRNDProjectResource: 'summary-resource/export-resource',
      ExportQualifyingExpenditure: 'summary-resource/export-cost-category',
    },
    AIUrl: {
      LlammaAI: 'ollama/generate',
    },
    AI: {
      ChatGPTAPI: 'ai/ai-response',
      ChatGPTCreateAPI: 'ai/create-chat',
      GetChatHistory: 'ai/chat-history/{sessionId}',
    },
    Tooltip: {
      SaveToolTip: 'toolTip/save',
      GetToolTip: 'toolTip/{ToolTipId}',
    },
  };
}
